module.exports = __webpack_public_path__ + "media/widget/MedicationList-64579477.png";